import { deepmergeCustom } from 'deepmerge-ts';

export const deepmerge = deepmergeCustom({
  mergeOthers: (value, utils) => {
    if (value[1] === '') {
      return value[0];
    }

    return utils.actions.defaultMerge;
  },
});
